import { render, staticRenderFns } from "./PDFVisualizer.vue?vue&type=template&id=fcca4c00&scoped=true"
import script from "./PDFVisualizer.vue?vue&type=script&lang=js"
export * from "./PDFVisualizer.vue?vue&type=script&lang=js"
import style0 from "./PDFVisualizer.vue?vue&type=style&index=0&id=fcca4c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcca4c00",
  null
  
)

export default component.exports